import { FC } from 'react'
import { Avatar, AvatarGlyph } from './styles'

interface Props {
    size: 'small' | 'medium'
}

const AiAvatar: FC<Props> = ({ size }) => (
    <Avatar $size={size}>
        <AvatarGlyph $size={size} />
    </Avatar>
)

export default AiAvatar
